import { render, staticRenderFns } from "./TBK_claim_details.vue?vue&type=template&id=27a9f5e3&"
import script from "./TBK_claim_details.vue?vue&type=script&lang=js&"
export * from "./TBK_claim_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports